import React from 'react';
import PropTypes from 'prop-types';
import ClaimDownloadIcon from 'products/nomad_insurance/assets/img/claims/claim-download-summary.svg';
import useClaimProgression from '../../../../hooks/useClaimProgression';
import { StyledDownloadButton, StyledImg, StyledLink } from './styled';

const ClaimDownloadSummaryButton = ({ claim }) => {
  const { isComplete, isDeclined } = useClaimProgression(claim);

  if (!(isComplete || isDeclined) || !claim.eobFileUrl) return null;

  return (
    <StyledLink href={claim.eobFileUrl} target="_blank" noOpener={false}>
      <StyledDownloadButton color="fountainBlue" thickness="thin">
        <StyledImg src={ClaimDownloadIcon} alt="Claim download" />
        Download summary
      </StyledDownloadButton>
    </StyledLink>
  );
};

ClaimDownloadSummaryButton.propTypes = {
  claim: PropTypes.object.isRequired
};

export default ClaimDownloadSummaryButton;
